import React from "react";

// App
import { Field, Section, TagList } from "./apiField";

const yesNo = (value) => {
  if (value === true) return "Yes";
  if (value === false) return "No";
  return null;
};

export default function LocationSection({ location, identity, raw }) {
  const { parking } = location;

  return (
    <Section
      id="location"
      title="Location"
      path="hotel.metadata / hotel.content.contactInfo"
      raw={raw}
    >
      <div className="rhp-grid">
        <Field
          label="Address"
          value={[location.address, location.zip, location.city]
            .filter(Boolean)
            .join(", ")}
          path={location.addressPath}
        />
        <Field label="City" value={location.city} path={location.cityPath} />
        <Field
          label="Country"
          value={location.country}
          path={location.countryPath}
        />
        <Field
          label="Region"
          value={location.region}
          path={location.regionPath}
        />
        <Field
          label="Continent"
          value={location.continent}
          path={location.continentPath}
        />
        <Field
          label="Coordinates"
          value={
            location.lat != null && location.lng != null
              ? `${location.lat}, ${location.lng}`
              : ""
          }
          path={`${location.latPath} / ${location.lngPath}`}
        />
        <Field label="Phone" value={location.phone} path={location.phonePath} />
        <Field label="Email" value={location.email} path={location.emailPath} />
        <Field
          label="Check in"
          value={location.checkIn}
          path={location.checkInPath}
        />
        <Field
          label="Check out"
          value={location.checkOut}
          path={location.checkOutPath}
        />
        <Field
          label="Hotel website"
          path={identity.linkUrlPath}
          value={identity.linkUrl}
        >
          {identity.linkUrl ? (
            <a
              href={`https://www.radissonhotels.com${identity.linkUrl}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              radissonhotels.com{identity.linkUrl}
            </a>
          ) : null}
        </Field>
      </div>

      <h3 className="rhp-subhead">Setting</h3>
      <TagList items={location.settings} path={location.settingsPath} />

      <h3 className="rhp-subhead">Points of interest</h3>
      <TagList items={location.poi} path={location.poiPath} />

      <h3 className="rhp-subhead">Parking</h3>
      <div className="rhp-grid">
        <Field
          label="Parking available"
          value={yesNo(parking.available)}
          path={parking.availablePath}
        />
        <Field label="Parking type" value={parking.type} path={parking.typePath} />
        <Field
          label="Indoor / outdoor"
          value={parking.indoorOutdoor}
          path={parking.indoorOutdoorPath}
        />
        <Field
          label="Free parking"
          value={yesNo(parking.isFree)}
          path={parking.isFreePath}
        />
        <Field
          label="Valet"
          value={yesNo(parking.valet)}
          path={parking.valetPath}
        />
        <Field
          label="Max vehicle height"
          value={parking.maxHeight}
          suffix={parking.maxHeight ? "cm" : ""}
          path={parking.maxHeightPath}
        />
        <Field
          label="Parking price"
          value={parking.price}
          path={parking.pricePath}
        />
      </div>
    </Section>
  );
}
